import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

export default function Carousel(el) {
    const buttons = el.querySelectorAll('.carousel__nav button');
    const bar = el.querySelector('.carousel__progress div');

    /* eslint-disable no-new */
    new Swiper(
        el.querySelector('.swiper'), {
            // autoplay: {
            //     disableOnInteraction: false,
            //     delay: 3000,
            //     pauseOnMouseEnter: true,
            // },
            grabCursor: true,
            loop: true,
            modules: [Autoplay, Navigation],
            navigation: {
                nextEl: buttons[1],
                prevEl: buttons[0],
            },
            on: {
                autoplayTimeLeft(s, time, progress) {
                    if (bar) {
                        bar.style.width = `${(1 - progress) * 100}%`;
                    }
                },
            },
            slidesPerView: 1,
        },
    );
    /* eslint-enable no-new */
}
